import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import browser from 'browser-detect'
import BackgroundImage from 'gatsby-background-image'
import { Link } from "@components/Link"
import { useURL } from "@hooks/useURL"
import { Pc, Sp } from "@hooks/useMediaQuery"

import css from "@css/components/blocks/IndexSct02.module.styl"


export default function IndexHero()
{
    const q = useStaticQuery(graphql`
        query {
            title: file(relativePath: { eq: "Hero__img__title.svg" }) {
                publicURL
            }
            device: file(relativePath: { eq: "Sct02__img__device@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 855) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            photo01: file(relativePath: { eq: "Sct02__img__photo-01@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 855) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            photo02: file(relativePath: { eq: "Sct02__img__photo-02@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 855) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            deviceSp: file(relativePath: { eq: "SpSct02__img__device@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 855) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            arrow01: file(relativePath: { eq: "Sct02__img__arrow01.svg" }) {
                publicURL
            }
            arrow02: file(relativePath: { eq: "Sct02__img__arrow02.svg" }) {
                publicURL
            }
            arrow01Sp: file(relativePath: { eq: "SpSct02__img__arrow01.svg" }) {
                publicURL
            }
            arrow02Sp: file(relativePath: { eq: "SpSct02__img__arrow02.svg" }) {
                publicURL
            }
        }
    `)

    const urls = useURL()
    return pug`
        div(className=${css.container})
            div(className=${css.inner})
                h2(className=${css.title})
                    span 撮るだけで、
                    span
                        |もれなく
                        strong 盛れる
                Pc
                    div(className=${css.content})
                        div(className=${css.device})
                            div(className=${css.inner})
                                Image(fluid=${q.device.childImageSharp.fluid})
                                div(className=${css.arrow01})
                                    img(src=${q.arrow01.publicURL} alt="")
                                div(className=${css.arrow02})
                                    img(src=${q.arrow02.publicURL} alt="")
                        div(className=${css.detail})
                            figure(className=${css.image})
                                div(className=${css.wrapper})
                                    Image(fluid=${q.photo01.childImageSharp.fluid})
                                figcaption(className=${css.caption}) 通常の撮影
                            figure(className=${css.image_express})
                                div(className=${css.wrapper})
                                    Image(fluid=${q.photo02.childImageSharp.fluid})
                                figcaption(className=${css.caption}) Photoshop Expressモードで撮影
                            p(className=${css.text})
                                |Photoshop Express モードなら、シャッターを押すだけでアドビの自動補正。
                                br
                                |逆光など表現が難しい景色もディティールにこだわった「盛れる写真」が手にはいります。
                            p(className=${css.text_small})
                                |※上記画像は既存のAdobe Stock画像に自動補正を適用したイメージ画像です。

                Sp
                    div(className=${css.content})
                        div(className=${css.detail})
                            figure(className=${css.image})
                                div(className=${css.wrapper})
                                    Image(fluid=${q.photo01.childImageSharp.fluid})
                                figcaption(className=${css.caption}) 通常の撮影
                            figure(className=${css.image_express})
                                div(className=${css.wrapper})
                                    Image(fluid=${q.photo02.childImageSharp.fluid})
                                figcaption(className=${css.caption}) Photoshop Expressモードで撮影
                            p(className=${css.text})
                                |Photoshop Express モードなら、シャッターを押すだけでアドビの自動補正。
                                br
                                |逆光など表現が難しい景色もディティールにこだわった「盛れる写真」が手にはいります。
                            p(className=${css.text_small})
                                |※上記画像は既存のAdobe Stock画像に自動補正を適用したイメージ画像です。
                            div(className=${css.device})
                                div(className=${css.inner})
                                    Image(fluid=${q.deviceSp.childImageSharp.fluid})
                                    div(className=${css.arrow01})
                                        img(src=${q.arrow01Sp.publicURL} alt="")
                                    div(className=${css.arrow02})
                                        img(src=${q.arrow02Sp.publicURL} alt="")

        `
}
